import React from 'react';
import { FadeIn } from './FadeIn';
import { CreditCard, Download, Rocket } from 'lucide-react';
export function PricingSection() {
  return <section id="comprar" className="py-12 bg-brand-50" data-id="element-108" data-mp="19jf89t6ofmsc">
      <div className="container mx-auto px-4" data-id="element-109" data-mp="1ehp7qfzfp9jr">
        <FadeIn data-id="element-110" data-mp="1egxgtigs7zzt">
          <div className="max-w-2xl mx-auto bg-white rounded-[2rem] shadow-2xl border-4 border-brand-200 overflow-hidden" data-id="element-111" data-mp="1egdzo3yyhfmu">
            <div className="bg-brand-500 text-center py-3" data-id="element-112" data-mp="1nb24jt0mcvb4">
              <span className="text-white font-bold text-base tracking-wider uppercase" data-id="element-113" data-mp="1ncmyphj0uc8g">
                Oferta Especial Limitada
              </span>
            </div>

            <div className="p-6 md:p-8 text-center" data-id="element-114" data-mp="1xa1f5h4y310r">
              <div className="mb-4" data-id="element-115" data-mp="227ta6k0vz396">
                <span className="text-slate-400 text-2xl line-through font-medium block mb-2" data-id="element-116" data-mp="226rshwpd7iih">
                  Precio Anterior: $49.900 ARS
                </span>
                <div className="flex items-center justify-center gap-4" data-id="element-117" data-mp="7tigny9cjkx2">
                  <span className="text-5xl md:text-6xl font-extrabold text-slate-900" data-id="element-118" data-mp="7vwe2dri197s">
                    $14.99
                  </span>
                  <span className="text-xl font-bold text-slate-900" data-id="element-119" data-mp="1hpoi26sk8tid">USD</span>
                </div>
                <div className="mt-4 inline-block bg-red-100 text-red-700 font-black px-4 py-1 rounded-full text-lg transform -rotate-2" data-id="element-120" data-mp="1cq3j3wde4l5n">
                  ¡70% OFF!
                </div>
              </div>

              <div className="space-y-3 mb-6 text-left max-w-sm mx-auto" data-id="element-121" data-mp="25ehhwecazli9">
                <div className="flex items-center gap-3 text-slate-700 font-medium" data-id="element-122" data-mp="20gph0utokp1x">
                  <CreditCard className="w-6 h-6 text-brand-500" data-id="element-123" data-mp="1vhcte7uzjdya" />
                  <span data-id="element-124" data-mp="1vfjksn0tajnn">¡Pagas en la moneda de tu pais 💳</span>
                </div>
                <div className="flex items-center gap-3 text-slate-700 font-medium" data-id="element-125" data-mp="1rezoflo2bk2k">
                  <Download className="w-6 h-6 text-brand-500" data-id="element-126" data-mp="k38z10khjnsp" />
                  <span data-id="element-127" data-mp="g0uhqkwgsw3j">
                    Entrega inmediata por PDF a tu email. ¡Descargás e imprimís
                    hoy mismo!
                  </span>
                </div>
              </div>

              <a href="https://100-citas-con-mi-hija-hijo.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="block w-full bg-brand-500 hover:bg-brand-600 text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-2xl shadow-xl shadow-brand-500/30 transition-all hover:scale-105 active:scale-95 flex items-center justify-center gap-3" data-id="element-128" data-mp="mgkxs1japgbp">
                ¡SÍ, QUIERO EL PACK AHORA! <Rocket className="w-6 h-6" data-id="element-129" data-mp="3k37lok3hohk" />
              </a>

              <p className="mt-4 text-sm text-slate-500 flex items-center justify-center gap-2" data-id="element-130" data-mp="3kzjja7gkb9j8">
                🔒 Pago 100% seguro y encriptado
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}